<template>
	<div>
		<v-sheet elevation="0" class="mt-4 pa-2">
			<v-row no-gutters>
				<v-col cols="4" v-show="options.isShowDropArea">
					<div id="drop-area">
						<h2 class="mb-4">{{ options.dropAreaTitle }}</h2>
						<v-card elevation="2" max-width="400" class="mx-auto">
							<v-virtual-scroll :items="options.dragItems" height="300" item-height="64">
								<template v-slot:default="{ item }">
									<v-list-item :key="item.id" class="fc-event">
										<v-list-item-content>
											<v-list-item-title> {{ item.name }} </v-list-item-title>
										</v-list-item-content>
									</v-list-item>

									<v-divider></v-divider>
								</template>
							</v-virtual-scroll>
						</v-card>
					</div>
				</v-col>
				<v-col :cols="options.isShowDropArea ? '8' : '12'">
					<!-- TODO loading表示 -->
					<!-- <Loading :isLoading="showLoading" /> -->
				</v-col>
				<v-col :cols="options.isShowDropArea ? '8' : '12'">
					<slot name="calendar-top-area" />
					<v-container>
						<FullCalendar id="calendar" ref="fullCalendar" :options="calendarOptions" />
					</v-container>
				</v-col>
			</v-row>
		</v-sheet>
		<div class="tooltip" :style="{ top: tooltipTop, left: tooltipLeft }" v-if="showTooltip">
			{{ tooltipText }}
		</div>
	</div>
</template>

<script>
import "@fullcalendar/core/vdom" // solves problem with Vite
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { Draggable } from "@fullcalendar/interaction"
import jaLocale from "@fullcalendar/core/locales/ja"
import * as holiday_jp from "@holiday-jp/holiday_jp"
import draggable from "vuedraggable"
import moment from "moment/min/moment.min.js"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import Loading from "../../view/shared/IndeterminateLoadingView.vue"

export default {
	components: {
		FullCalendar,
		draggable,
		Loading,
	},
	props: {
		authority: {
			type: String,
		},
		options: {
			type: Object,
			required: false,
			default: () => {},
			// ドロップエリアのタイトル
			dropAreaTitle: {
				type: String,
			},
			// 予めカレンダーに予定をいれたい場合に使用
			events: {
				type: Array,
				required: false,
				default: () => [],
			},
			//ドラッグしたいオブジェクト
			dragItems: {
				type: Array,
				required: false,
				default: () => [],
			},
			// ドロップエリアを表示切り替え
			isShowDropArea: {
				type: Boolean,
			},
			// リクエスト用のurl
			url: {
				type: String,
				required: false,
			},
			// 送るparameter
			params: {
				type: Object,
				required: false,
				default: () => ({}),
			},
			// fetchDataを発火させるかどうか
			isFetchData: {
				type: Boolean,
				required: true,
				default: true,
			},
		},
		calenderLoading: {
			type: Boolean,
			required: true,
			default: true,
		},
	},
	data() {
		return {
			showTooltip: false,
			tooltipTop: 0,
			tooltipLeft: 0,
			tooltipText: "",
			month: null,
			calendarOptions: {
				locale: jaLocale,
				timeZone: "Asia/Tokyo",
				plugins: [dayGridPlugin, interactionPlugin],
				selectable: true,
				// デフォルトで表示するビュー
				initialView: "dayGridMonth",
				// ドラッグ設定
				editable: true,
				droppable: true,
				headerToolbar: {
					// 切り替えで表示するビュー
					left: "dayGridMonth,dayGridWeek,dayGridDay",
					center: "title",
					right: "today prev,next",
				},
				buttonText: {
					today: "今月",
					month: "月",
					list: "リスト",
				},
				titleFormat: {
					year: "numeric",
					month: "long",
					day: "numeric",
					weekday: "narrow",
				},
				buttonText: {
					today: "今日",
					month: "月",
					week: "週",
					day: "日",
					list: "リスト",
				},
				customButtons: {
					prev: {
						// this overrides the prev button
						text: "PREV",
						click: () => {
							let calendarApi = this.$refs.fullCalendar.getApi()
							let calendar_date = calendarApi.currentData.currentDate
							let year = calendar_date.getFullYear()
							let month = calendar_date.getMonth() - 1
							// NOTE 月の指定は0から始まるため注意
							const selected_month = moment(`${year}-${month + 1}`).format("YYYY-MM")
							this.fetchData(selected_month)
							const prev_date = new Date(year, month)
							this.setHoliday(prev_date)
							calendarApi.prev()
						},
					},
					next: {
						// this overrides the next button
						text: "Next",
						click: () => {
							let calendarApi = this.$refs.fullCalendar.getApi()
							let calendar_date = calendarApi.currentData.currentDate
							let year = calendar_date.getFullYear()
							let month = calendar_date.getMonth() + 1
							// NOTE 月の指定は0から始まるため注意
							const selected_month = moment(`${year}-${month + 1}`).format("YYYY-MM")
							this.fetchData(selected_month)
							const next_date = new Date(year, month)
							this.setHoliday(next_date)

							calendarApi.next()
						},
					},
				},
				events: [],
				// カラー
				eventColor: "rgba(7, 33, 77, 0.55)",
				// 関数群
				dateClick: this.handleDateClick,
				eventDrop: this.updateScheduleCalendar,
				eventResize: this.eventResize,
				changeMonth: this.changeMonth,
				eventClick: this.eventClick,
				// 外部からのドロップ時
				drop: function (e) {
					// const objectId = e.draggedEl.id
				},
			},
		}
	},
	mounted() {
		this.setHoliday()
		const draggableEl = document.getElementById("drop-area")
		new Draggable(draggableEl, {
			itemSelector: ".fc-event",
			eventData: function (eventEl) {
				return {
					title: eventEl.innerText,
				}
			},
		})
	},
	methods: {
		fetchData(selected_month) {
			this.showLoading = true
			const headers = authenticate.setHeader()
			const params = { ...this.options.params, month: selected_month }

			axios
				.get(this.options.url, {
					headers,
					params: params,
				})
				.then((res) => {
					this.$emit("next-data", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => (this.showLoading = false))
		},
		showFullName(name) {
			this.showTooltip = true
			this.tooltipText = name
			this.updateTooltipPosition()
		},
		hideFullName() {
			this.showTooltip = false
		},
		updateTooltipPosition() {
			// ツールチップの位置を更新
			const target = this.$refs.target
			const tooltip = this.$el.querySelector(".tooltip")
			const targetRect = target.getBoundingClientRect()
			const tooltipRect = tooltip.getBoundingClientRect()
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
			const scrollLeft =
				window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0
			const top = targetRect.top + scrollTop - tooltipRect.height - 10
			const left = targetRect.left + scrollLeft + (targetRect.width - tooltipRect.width) / 2
			this.tooltipTop = `${top}px`
			this.tooltipLeft = `${left}px`
		},
		// 読み込み時の表示月を変更したい場合に使用
		defaultViewHandling(date) {
			this.$refs.fullCalendar.getApi().changeView("dayGridMonth", date)
		},
		setHoliday(prev_or_next_date) {
			if (prev_or_next_date) {
				const setDate = this.setDate(prev_or_next_date)
				this.makeEvent(setDate)
			} else {
				const today = new Date()
				const setDate = this.setDate(today)
				this.makeEvent(setDate)
			}
		},
		makeEvent(date_obj) {
			let holidays = holiday_jp.between(date_obj.startDate, date_obj.endDate)

			const new_holidays = this.changeKey(holidays)
			new_holidays.forEach((new_holiday) => {
				this.calendarOptions.events.push(new_holiday)
			})
			this.removeDuplicationEvent()
		},
		removeDuplicationEvent() {
			this.calendarOptions.events = this.calendarOptions.events.filter((event, index, array) => {
				return array.findIndex((v) => event.title === v.title) === index
			})
		},
		changeKey(holidays) {
			const new_events = holidays.map((holiday) => {
				return {
					title: holiday.name,
					start: holiday.date,
					className: "holiday",
					id: "holiday",
					allDay: true,
				}
			})
			return new_events
		},
		setDate(date) {
			const startDate = new Date(date.getFullYear(), date.getMonth(), 1)
			const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
			return { startDate, endDate }
		},
		handleDateClick(arg) {
			const date = arg.date
			this.$emit("open", date)
		},
		// 日を跨いでドラッグアンドドロップした場合
		updateScheduleCalendar(event) {
			const id = event.event["_def"].publicId
			const datetime = event.event["_instance"].range
			this.$emit("cross", { datetime, id })
		},
		// イベントのサイズを変更した場合
		eventResize(event) {
			const id = event.event["_def"].publicId
			const datetime = event.event["_instance"].range
			this.$emit("resize", { datetime, id })
		},
		eventClick(event) {
			const id = event.event["_def"].publicId
			this.$emit("open-dialog", id)
		},
	},
	computed: {
		showLoading: {
			get() {
				return this.calenderLoading
			},
			set(newVal) {
				return this.$emit("update:calenderLoading", newVal)
			},
		},
	},
	watch: {
		options: {
			deep: true,
			handler(newVal, oldVal) {
				this.calendarOptions.events = []
				this.setHoliday()
				this.options.events.forEach((event) => {
					if (!this.calendarOptions.events.includes(event)) {
						this.calendarOptions.events.push(event)
					}
				})
				this.removeDuplicationEvent()

				if (newVal.isFetchData) {
					// NOTE 必要に応じてmonthを加工
					this.fetchData(this.month)
				}
			},
		},
		authority(newVal) {
			// 権限がなければ読み取りのみ
			if (newVal == "read_only") {
				this.calendarOptions.editable = false
			}
		},
	},
}
</script>

<style lang="scss">
@import "../../stylesheet/variable.scss";
td.fc-day-sat {
	background: $calendar-sunday-color;
}
td.fc-day-sun {
	background-color: $calendar-sunday-color;
}
.fc-event-title {
	font-weight: bold;
}
.holiday {
	background-color: white !important;
	border: none !important;
	display: flex !important;
	align-items: center;
	color: black !important;
}
.holiday::before {
	content: "";
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: skyblue;
	margin-right: 3px;
	margin-top: 3px;
}
#external-events {
	padding: 45px;
}

.fc-event-title-container {
	.fc-sticky {
		color: white;
	}
}
.holiday {
	.fc-event-main {
		.fc-event-main-frame {
			.fc-event-title-container {
				.fc-sticky {
					color: black;
				}
			}
		}
	}
}
.v-progress-circular__overlay {
	color: red !important;
}
</style>
